module.exports = __webpack_public_path__ + "118b4e16c3f3b29919ce066942521eff.jpg";